<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">New Uniform</div>
                    </div>
                    <div class="form mt-3">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group form-group-2" v-if="specificApplicant">
                                    <p>{{ userName }}</p>
                                </div>
                                <div class="form-group form-group-2" v-else>
                                    <CommonSearch
                                        :label="'Employee Name'"
                                        :type="'applicant'"
                                        :selected-item="request.employee_id"
                                        @update-info="updateEmployeeId"
                                    />
                                </div>
                            </div>
                            <div class="col-md-12 d-flex flex-wrap">
                                <div class="form-group form-group-2 mr-4">
                                    <label for="" class="form-label">Does the employee want this uniform to be delivered
                                        to the primary location or to the main office?</label>
                                </div>
                                <div class="d-flex">
                                    <div class="form-group form-group-2 mr-3">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio"
                                                name="name12"
                                                id="office"
                                                :value="true"
                                                v-model="request.isMainOffice"
                                                @change="clearLocation"
                                            >
                                            <label class="form-check-label" for="office">
                                                <nobr> Main Office</nobr>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group form-group-2 mr-3">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio" name="name12"
                                                id="primary"
                                                :value="false"
                                                v-model="request.isMainOffice"
                                            >
                                            <label class="form-check-label" for="primary">
                                                <nobr>Primary Location</nobr>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="request.isMainOffice === false">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Primary Location</label>
                                    <select class="form-control" v-model="request.location">
                                        <option
                                            v-for="client in clientsList"
                                            :key="client.id"
                                            :value="client.id"
                                        >
                                            {{ client.name }}
                                        </option>
                                    </select>
                                    <small>Please keep in mind each location and position has specific requirement. If
                                        you request an time that is not part of YOUR location’s uniform, your request
                                        will be denied.</small>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="table-holder table-responsive ">
                                    <table class="table ">
                                        <thead>
                                        <tr>
                                            <th>Inventory Item</th>
                                            <th style="width: 7rem">Size</th>
                                            <th style="width: 6rem">Quantity</th>
                                            <th style="width: 4rem"></th>
                                        </tr>
                                        </thead>

                                        <InventoryItemInRequest
                                            @update-uniforms="updateRequest"
                                            :show-input="showTypeInput"
                                        />

                                    </table>
                                </div>
                            </div>
                            <div class="col-12 text-right mb-4">
                                <a href="javascript:void(0)"
                                   class="btn btn--outline-primary btn--middle"
                                   @click="addNewItem"
                                >+ Add New</a>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Comment</label>
                                    <textarea type="text" class="form-control height-2"
                                              v-model="request.comment"></textarea>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="btns-wrap">
                                    <button
                                        @click="redirectToPage"
                                       class="btn btn--outline-primary w-100 w-sm-auto">Cancel</button>
                                    <button
                                        class="btn btn--secondary w-100 w-sm-auto"
                                        @click="validateRequest">
                                        Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";
import UniformsService from "./service/UniformsService";
import CommonSearch from "../../../../../resources/js/components/CommonSearch.vue";
import InventoryItemInRequest from "./InventoryItemInRequest.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'NewUniformRequest',
    mixins: [ModalHandler,],
    components: {InventoryItemInRequest, CommonSearch, VueMultiSelect},
    props: {
        specificApplicant: {
            type: Boolean,
            required: false,
        },
        userName: {
            type: String
        },
        userId: {
            type: Number
        },
    },
    data() {
        return {
            request: {
                employee_id: this.userId ?? null,
                uniforms: [],
                location: null,
                comment: null,
                isMainOffice: true,
            },

            clientsList: [],
            showTypeInput: false,
        }
    },
    methods: {

        clearLocation() {
            this.request.location = null
        },
        updateEmployeeId(result) {
            this.request.employee_id = result
        },
        addNewItem() {
            this.showTypeInput = true
        },
        updateRequest(uniforms) {
            this.showTypeInput = false
            this.request.uniforms = uniforms
        },
        async getClientsList() {
            try {
                const {data: clients} = await CommonService.getClientsList()
                this.clientsList = clients
            } catch (e) {
                console.error()
                this.$showErrorMessage();
            }
        },
        validateRequest() {
            if (this.request.uniforms.length === 0) {
                this.$showErrorMessage('You haven\'t chosen a uniform');
                return
            }
            if (!this.request.employee_id) {
                this.$showErrorMessage('You haven\'t chosen an employee');
                return
            }
            if (!this.request.isMainOffice && !this.request.location) {
                this.$showErrorMessage('You haven\'t chosen location');
            } else {
                this.sendRequest()
            }
        },

        async sendRequest() {
            this.$showLoadingMessage()
            try {
                await UniformsService.sendNewRequest(this.request)
                this.$showSuccessMessage('Request was sent')
                this.redirectToPage()
            } catch (e) {
                this.$showErrorMessage('Request was not sent. Please try again');
            }
        },
        redirectToPage() {
            if (this.specificApplicant) {
                setTimeout(() => {
                    window.location.href = `/master-admin/applicants/${this.userId}/show?tab=Uniforms`
                }, 1000)
            } else {
                setTimeout(() => {
                    window.location.href = '/master-admin/uniforms/log'
                }, 1000)
            }
        },

        async loadData() {
            this.loading = true;
            try {
                await Promise.all([this.getClientsList(),]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.loadData()
    }
}

</script>


<style scoped>

</style>
